import React from 'react';
import { motion } from 'framer-motion';

const Process: React.FC = () => {
  const steps = [
    {
      id: 1,
      title: "Analyze",
      description: "Start with an onboarding call to go over your current process in detail by asking specific questions"
    },
    {
      id: 2,
      title: "Design",
      description: "Define the required databases, automations, formulas, and tool stack based on the challenges uncovered"
    },
    {
      id: 3,
      title: "Build",
      description: "Design and build custom AI solutions and dashboards to match your specific requirements"
    },
    {
      id: 4,
      title: "Optimize",
      description: "Monitor system performance, gather team feedback, and implement iterative improvements"
    }
  ];

  return (
    <div className="bg-black py-24">
      <div className="container mx-auto px-4">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-5xl font-bold text-center mb-6"
        >
          Our Process
        </motion.h2>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-xl text-gray-300 text-center max-w-3xl mx-auto mb-16"
        >
          Our four-step process keeps you informed and involved at every stage,
          ensuring the final result meets your goals and resonates with your needs.
        </motion.p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              <div className="bg-primary/30 backdrop-blur-sm rounded-xl p-8 h-full">
                <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center mb-6">
                  <span className="text-accent font-bold">{step.id.toString().padStart(2, '0')}</span>
                </div>
                
                <h3 className="text-2xl font-bold mb-4">{step.title}</h3>
                <p className="text-gray-300">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="flex justify-center mt-12"
        >
          <a 
            href="#contact" 
            className="bg-accent/10 hover:bg-accent/20 text-accent border border-accent/30 font-medium px-8 py-4 rounded-md text-lg transition-all duration-300 inline-flex items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" />
            </svg>
            Schedule a consultation
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Process;
